import PresetMedia from './PresetMedia';
import Bullseye from '../presets/animations/Bullseye';
import Clap from '../presets/animations/Clap';
import Fade from '../presets/animations/Fade';
import Flex from '../presets/animations/Flex';
import Shutter from '../presets/animations/Shutter';
import Split from '../presets/animations/Split';
import Stacked from '../presets/animations/Stacked';
import Falling from '../presets/animations/Falling';
import StepUp from '../presets/animations/StepUp';
import Radar from '../presets/animations/Radar';

export const screenAnimations = {
  bullseye: 'bullseye',
  clap: 'clap',
  fade: 'fade',
  flex: 'flex',
  shutter: 'shutter',
  split: 'split',
  stacked: 'stacked',
  stepup: 'stepup',
  radar: 'radar',
  falling: 'falling',
};

export default class AnimationMedia extends PresetMedia {
  createPreset(model) {
    let preset = null;

    switch (model.animationPreset) {
      case screenAnimations.bullseye:
        preset = new Bullseye(this.app);
        break;
      case screenAnimations.clap:
        preset = new Clap(this.app);
        break;
      case screenAnimations.fade:
        preset = new Fade(this.app);
        break;
      case screenAnimations.flex:
        preset = new Flex(this.app);
        break;
      case screenAnimations.shutter:
        preset = new Shutter(this.app);
        break;
      case screenAnimations.split:
        preset = new Split(this.app);
        break;
      case screenAnimations.stacked:
        preset = new Stacked(this.app);
        break;
      case screenAnimations.stepup:
        preset = new StepUp(this.app);
        break;
      case screenAnimations.radar:
        preset = new Radar(this.app);
        break;
      case screenAnimations.falling:
        preset = new Falling(this.app);
        break;
      default:
        preset = new Radar(this.app);
    }

    this.setPreset(preset, model.animationPreset || screenAnimations.radar);
  }
}
